import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import approvalsService from '../services/approvals/approvals.service';
import { ApprovalType } from '../types/approvals.types';
import { PermissionType } from '../types/user.types';
import { RolesEnum } from '../types/route.types';
import { createPollingStore } from '../utils/createPollingStore';

export interface ApprovalCountsSnapshot {
  total: number;
  counts: Partial<Record<ApprovalType, number>>;
}

/** Header, sidebar ve Onaylar sayfası arasında paylaşılan bekleyen onay sayacı (60 sn'de bir yenilenir) */
export const approvalCountsStore = createPollingStore<ApprovalCountsSnapshot>(
  () => approvalsService.getApprovalCounts().then((res) => ({ total: res.total, counts: res.counts })),
  { total: 0, counts: {} },
  60000
);

const REVIEWER_ROLES: string[] = [RolesEnum.ADMIN, RolesEnum.MANAGER, RolesEnum.SUPERADMIN];

/** Oturumdaki kullanıcı onay verebilir mi? (admin / yönetici) */
export const useIsApprovalReviewer = (): boolean => {
  const user = useSelector((state: RootState) => state.auth.user);
  if (!user) return false;
  const hasPanelPermission = (user.permissions as string[] | undefined)?.includes(PermissionType.CONTROL_PANEL_ADMIN) ?? false;
  return hasPanelPermission && REVIEWER_ROLES.includes(user.role);
};

export const useApprovalCounts = (): ApprovalCountsSnapshot => {
  const isReviewer = useIsApprovalReviewer();
  return approvalCountsStore.useValue(isReviewer);
};
